export const theme = {
	color: {
		white: '#fff',
		porcelain: '#e2E8Ea',
		porcelainSecond: '#f5F7F8',
		porcelainLight: '#e5Eaec',
		porcelainSecondLight: '#f7F9F9',
		iron: '#cbd1D3',
		ironSecond: '#dcdedf',
		casper: '#90a4Ae',
		mercury: '#e5E5E5',
		dodgerBlue: '#4c6Cff',
		dodgerBlueLight: '#5e7Bff',
		royalBlue: '#4461e6',
		bostonBlue: '#367ab9',
		endeavour: '#0459a8',
		congressBlue: '#045097',
		brilliantBlue: '#0075dc',
		curiousBlue: '#2784da',
		iceberg: '#cdf2ed',
		linkWater: '#cddeee',
		spindle: '#b4Cde5',
		cyprus: '#002d3C',
		gossamer: '#06bea6',
		emerald: '#4fc35A',
		hokeyPokey: '#fabe34',
		hokeyPokeyLight: '#f9C858',
		anzac: '#e1B141',
		cerise: '#d63F5a',
		sunsetOrange: '#fe493f',
		wePeep: '#f7d9de',
		ebony: '#130f26',
		abbey: '#4e5457',
		osloGrey: '#7f888c',
		loblolly: '#c1c8cc',
		jumbo: '#7d7d84',
		blackPearl: '#061D24',
		blueBayoux: '#4b6a75'
	},
	mixin: {
		subtitle: () => ` margin-top: 32px;
                        margin-bottom: 4px;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;`,

		title: () => `  font-size: 26px;
                    line-height: 30px;
                    letter-spacing: -0.2px;
                    margin-top: 0;
                    margin-bottom: 0;
                    color: #130f26;
                    white-space: pre-line;
  `
	}
};
export type ThemeType = typeof theme;
